import axios from "axios";
import { getUserData } from "../utils";

let requestInterceptor: any;
export const setAxiosConfig = () => {
  const userData = getUserData();
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  axios.defaults.withCredentials = true;

  // console.log("requestInterceptor");
  // console.log(requestInterceptor);
  // window.location.replace('/maintenance');

};

export const clearAxiosConfig = () => {
  axios.interceptors.request.eject(requestInterceptor);
};
